// extracted by mini-css-extract-plugin
export default {"playBtn":"VideoPlayIcon_playBtn__lSv9F","newsVideoPlayIcon":"VideoPlayIcon_newsVideoPlayIcon__zKmg2","newsVideoListPlayIcon":"VideoPlayIcon_newsVideoListPlayIcon__mE668"};